import Page from 'flarum/common/components/Page';
import Group from 'flarum/common/models/Group';
import SignUpModal from 'flarum/forum/components/SignUpModal';

export default class Test extends Page {
    oninit() {
        this.auth_route = '/all';
        this.join = () => app.modal.show(SignUpModal);
        if (app.forum.attribute('landing.auth_route') != undefined) {
            this.auth_route = app.forum.attribute('landing.auth_route');
        }
        this.content = (
            <div id='landing-page'>
                <script>{window.location.pathname == '/' ? document.getElementById('app').style.paddingBottom = 0 : ''}</script>
                <script>{window.location.pathname == '/' ? document.querySelector('.App-content').style.paddingBottom = 0 : ''}</script>
                <div id="landing-header">
                    <div class="left-side">
                        <img src={app.forum.attribute('baseUrl') + '/assets/' + app.forum.attribute('landing.logo_path')} />
                    </div>
                    <div class="right-side">
                        <div class="text-block">
                            {/* <h1>The Clubhouse</h1> */}
                            <p>an exclusive community of golfing philanthropists</p>
                        </div>
                    </div>
                </div>
                <div id="body">
                    <img src={app.forum.attribute('baseUrl') + '/assets/' + app.forum.attribute('landing.bg_path')} />
                    <div id="body-content">
                        <div id="bullet-points">
                            <div class="content-heading">
                                <h2 class="bullet-title">Clubhouse Membership Benefits Include:</h2>
                            </div>
                            <div class="bullets">
                                <ul>
                                    <li>
                                        <div id="pop-1" class="popover__wrapper">
                                            <p class="popover__title">Private message board<a href="#pop-1" class="see-more">SEE MORE</a></p>
                                            <div class="popover__content">
                                                <p class="popover__message">
                                                    Creating a community is paramount to The Clubhouse. We’re focused on
                                                    fostering a group of philanthropic golfers who will get to know each other, share
                                                    ideas and ultimately golf for a cause!
                                                </p>
                                            </div>
                                        </div>
                                    </li>
                                    <li>
                                        <div id="pop-2" class="popover__wrapper">
                                            <p class="popover__title">Twenty-Four (24) Hour Early Access to Auctions<a href="#pop-2" class="see-more">SEE MORE</a></p>
                                            <div class="popover__content">
                                                <p class="popover__message">
                                                    Members of The Clubhouse will get 24 hour early access to all of our auctions,
                                                    allowing you the opportunity to “Buy it Now” on top experiences before the general
                                                    public.
                                                </p>
                                            </div>
                                        </div>
                                    </li>
                                    {/* <li>
                                        <div id="pop-3" class="popover__wrapper">
                                            <p class="popover__title">Invitations to Clubhouse only Events at Top Courses<a href="#pop-3" class="see-more">SEE MORE</a></p>
                                            <div class="popover__content">
                                                <p class="popover__message">
                                                    Throughout the year we’ll have several events at highly ranked clubs. Some of
                                                    these events will be for Clubhouse members ONLY.
                                                </p>
                                            </div>
                                        </div>
                                    </li> */}
                                    <li>
                                        <div id="pop-4" class="popover__wrapper">
                                            <p class="popover__title">Early Access and 10% Discounts to our General Events<a href="#pop-4" class="see-more">SEE MORE</a></p>
                                            <div class="popover__content">
                                                <p class="popover__message">
                                                    Clubhouse members will get early access and 10% off all our general events (in
                                                    addition to our Clubhouse only events).
                                                </p>
                                            </div>
                                        </div>
                                    </li>
                                    <li>
                                        <div id="pop-5" class="popover__wrapper">
                                            <p class="popover__title">Special Upgrades/Discounts from Preferred Partners<a href="#pop-5" class="see-more">SEE MORE</a></p>
                                            <div class="popover__content">
                                                <p class="popover__message">
                                                    We’ve partnered up with some awesome brands to give you discounts to some of
                                                    our favorite products and services.
                                                </p>
                                            </div>
                                        </div>
                                    </li>
                                    <li>
                                        <div id="pop-6" class="popover__wrapper">
                                            <p class="popover__title">Annual Gift<a href="#pop-6" class="see-more">SEE MORE</a></p>
                                            <div class="popover__content">
                                                <p class="popover__message">
                                                    Member for a Day swag delivered straight to your doorstep at the end of the year
                                                </p>
                                            </div>
                                        </div>
                                    </li>
                                    <li>
                                        <div id="pop-7" class="popover__wrapper">
                                            <p class="popover__title">Direct Booking Concierge Service (subject to availability and discretion of host)<a href="#pop-7" class="see-more">SEE MORE</a></p>
                                            <div class="popover__content">
                                                <p class="popover__message">
                                                    Traveling to a new city and interested in getting on a specific course? Clubhouse
                                                    members can reach out to us to see if we can help you get on a specific course.
                                                    Through our charitable network of member hosts, we will attempt to set up a
                                                    round of golf all the while supporting the host member’s charity of choice. These
                                                    rounds will be a pre-deteremined additional cost on an a la carte basis.
                                                </p>
                                            </div>
                                        </div>
                                    </li>
                                    <li>
                                        <div id="pop-8" class="popover__wrapper">
                                            <p class="popover__title">20% off Member for a Day Merchandise<a href="#pop-8" class="see-more">SEE MORE</a></p>
                                            <div class="popover__content">
                                                <p class="popover__message">
                                                    Let everyone know that you Golf for a Cause with our Member for a Day
                                                    merchandise. Clubhouse members will be the first in our community to gain
                                                    access to limited edition drops and promotional merchandise!
                                                </p>
                                            </div>
                                        </div>
                                    </li>
                                    <li>
                                        <div id="pop-9" class="popover__wrapper">
                                            <p class="popover__title">Dedicated Clubhouse Customer Service (two-hour response time during business hours)<a href="#pop-9" class="see-more">SEE MORE</a></p>
                                            <div class="popover__content">
                                                <p class="popover__message">
                                                    Need to get in touch with someone from our customer service team? Clubhouse
                                                    members have a dedicated email that during business hours we will get back to
                                                    you in under two hours.
                                                </p>
                                            </div>
                                        </div>
                                    </li>
                                    <li>
                                        <div id="pop-10" class="popover__wrapper">
                                            <p class="popover__title">🔮 Crystal Ball View<a href="#pop-10" class="see-more">SEE MORE</a></p>
                                            <div class="popover__content">
                                                <p class="popover__message">
                                                    Sneak peak access to view select items from our upcoming auctions
                                                </p>
                                            </div>
                                        </div>
                                    </li>
                                    <li>
                                        <div id="pop-11" class="popover__wrapper">
                                            <p class="popover__title">A Dormie Network Stay & Play (additional cost)<a href="#pop-11" class="see-more">SEE MORE</a></p>
                                            <div class="popover__content">
                                                <p class="popover__message">
                                                    Thanks to our amazing partners at Dormie Network you’re allowed one stay &
                                                    play at any of their amazing courses (Dormie Club Excluded)
                                                </p>
                                            </div>
                                        </div>
                                    </li>
                                    <li>
                                        <div id="pop-12" class="popover__wrapper">
                                            <p class="popover__title">Bucket-List Course Notifications<a href="#pop-12" class="see-more">SEE MORE</a></p>
                                            <div class="popover__content">
                                                <p class="popover__message">
                                                    Get personal notifications and be the first to know when a course on your bucket list is up for bid!
                                                </p>
                                            </div>
                                        </div>
                                    </li>
                                    {/* <li>
                                        <div id="pop-12" class="popover__wrapper">
                                            <p class="popover__title">Ability to pay for direct-booking concierge items with a Donor Advised Fund (coming soon)<a href="#pop-12" class="see-more">SEE MORE</a></p>
                                            <div class="popover__content">
                                                <p class="popover__message">
                                                    One of our most requested features and one that is only available to Clubhouse
                                                    members. Pay for direct-booking concierge purchases using your donor advised
                                                    fund!
                                                </p>
                                            </div>
                                        </div>
                                    </li> */}
                                </ul>
                            </div>
                        </div>
                        <div id="more-info">
                            <div class="info-title">
                                <h2>PLUS:</h2>
                            </div>
                            <div class="info-text">
                                Be one of the first 40 people to join and receive a signed print of your choice from famed golf artist Lee Wybranski
                            </div>
                        </div>
                    </div>
                </div>
                <div id="price-info">
                    <span style={{ display: 'flex', justifyContent: 'center' }}>
                        <img style={{ marginRight: '25px' }} class='down-arrow' src={app.forum.attribute('baseUrl') + '/assets/arrow-down.png'} />
                        <h2>Join for $99/month or $999 for the year </h2>
                        <img class='down-arrow' style={{ marginLeft: '25px' }} src={app.forum.attribute('baseUrl') + '/assets/arrow-down.png'} />
                    </span>
                </div>
                <div id="join-section">
                    <div class="join-button">
                        <a onclick={this.join}>
                            Join Today <img style={{ marginLeft: '15px' }} src={app.forum.attribute('baseUrl') + '/assets/arrow-right-circled.png'} />
                        </a>
                    </div>
                    <div class="footnotes">
                        {/* <div class="footnote-text">
                            <p>* Subject to availability and discretion of host</p>
                            <p>** Subject to continued Clubouse membership through the date of the event</p>
                        </div> */}
                    </div>
                </div>
                {/* <div class='landing-page-content'>
                        <h1>{app.forum.attribute('landing.title')}</h1>
                        <p>{app.forum.attribute('landing.subtitle')}</p>
                        {m.trust(app.forum.attribute('landing.title'))}
                    </div> */}
                <div class="footer-container">
                    <div id="landing-footer">
                        <div class="left-side">
                            <p>© Member for a day <span id="date">{new Date().getFullYear()}</span></p>
                            <br></br>
                            <p>Follow Member for a Day @</p>
                            <p class="social-links">
                                <a href="https://www.instagram.com/memberforaday/?hl=en" target="_blank">Instagram </a>
                                +
                                <a href="https://twitter.com/member4aday?lang=en" target="_blank"> Twitter </a>
                                +
                                <a href="https://www.youtube.com/channel/UCPOh52EkRWSRq7X5ZWXiQqw" target="_blank"> Youtube </a>
                            </p>
                        </div>
                        <div class="right-side">
                            <a href={app.forum.attribute('footer.privacy_link')}>Privacy Policy</a>
                            <a href={app.forum.attribute('footer.terms')}>Terms of Use</a>
                            <a href={app.forum.attribute('footer.guidelines')}>Guidelines</a>
                            <a href={app.forum.attribute('footer.faq')}>FAQ</a>
                            <a href={'mailto:' + app.forum.attribute('footer.email')} >Contact Us</a>
                        </div>
                    </div>
                </div>
            </div>
        )
        if (app.session.user) {
            this.content = '';

            var isActivated = false;
            // var group = Object.entries(app.store.data.groups).find(g => g[1].data.attributes.nameSingular == 'activated')[1];
            // var uGroup = Object.entries(app.session.user.data.relationships.groups.data)[0][1].id;

            // if(group.data.id === uGroup){
            //     isActivated = true;
            // }
            // console.log('look here', Object.entries(app.session.user.data.relationships.groups.data)[0][1].id)
            // console.log('look again', Object.entries(group.store.data.users).find(r => r[1].data.attributes.id == group.data.attributes.id) )
            // console.log('better way', app.store.getById('groups', Group.GUEST_ID))
            // if(isActivated){
            m.route.set(this.auth_route)
            // } else {
            // m.route.set('/subscribe')
            // }

        }
    }

    view() {
        return this.content;
    }
}

